/**
 * .fileupload
 * Add nice styling for the fileupload fields
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(function()
{
    "use strict";

    // Define the method to call upon the field
    var updateField = function() {
        $('.btn-file :file').on('fileselect', function(event, numFiles, label) {
                // Get the text of the parent input
                var input = $(this).parents('.input-group').find(':text'),
                    // Check the number of files we upload
                    log = numFiles > 1 ? numFiles + ' files selected' : label;
                // If present
                if( input.length ) {
                    input.val(log);
                } else {
                    if( log ) alert(log);
                }
        });
    };

    // Bind Trigger to field
    $(document).on('change', '.btn-file :file', function() {
        var input = $(this),
            numFiles = input.get(0).files ? input.get(0).files.length : 1,
            label = input.val().replace(/\\/g, '/').replace(/.*\//, '');

        input.trigger('fileselect', [numFiles, label]);
    });

    // Bind the method to Document
    $(document).ready(updateField);
    // Bind the show.bs.modal
    $(document).on('show.bs.modal', updateField);
});
